import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "InfoRequest" })
export default class InfoRequest extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = {};
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    get isInfoRequestVisible() {
        return this.$store.getters["infoRequestStore/isInfoRequestVisible"];
    }

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly requestUrl: string;

    @Watch("isInfoRequestVisible") onInfoRequestVisibilityUpdate(newValue: boolean) {
        if (newValue) {
            document.body.classList.add("overflow");
            (<any>this).$refs.infoRequestModal.classList.add("show");
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.infoRequestModal.classList.remove("show");
        }
    }

    public created() {
        this.setOpenInfoRequest();
    }

    public setOpenInfoRequest() {
        if (this.$route.query.hasOwnProperty("inforequest")) {
            this.$store.commit("infoRequestStore/setInfoRequestVisible", true);
        }
    }

    public async submitForm() {
        this.validationErrors = [];
        this.isLoading = true;
        this.formData.requestUrl = this.requestUrl;

        (<any>window).grecaptcha.enterprise.ready(async () => {
            const token = await (<any>window).grecaptcha.enterprise.execute(this.recaptchaSiteKey, { action: 'Submit' });

            try {
                await Axios.post(this.routes.Contact_InfoRequest, this.formData, { headers: { "RecaptchaVerificationToken": token } });

                this.isSuccess = true;

                GTagHelper.sendEvent("form_submit", "info_request", "website");
                
                // ADS
                GTagHelper.sendCustomEvent('conversion', {'send_to': 'AW-16970702946/xJlSCOGHx7MaEOLAoZw_', 'value': 1.0, 'currency': 'EUR' });

            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }
        });

        this.isLoading = false;
    }

    public closeInfoRequest() {
        this.$store.commit("infoRequestStore/setInfoRequestVisible", false);
        this.isLoading = false;
        this.isSuccess = false;
        this.formData = {};
        this.validationErrors = [];
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};